import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/useAuthStore';
import { signOut } from '@/services/firebase';
import DashboardHeader from '@/components/Dashboard/DashboardHeader';

const linkBaseClasses =
  'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors';

const AdminLayoutPage = () => {
  const navigate = useNavigate();
  const { user, role, accessLevel, signOut: signOutStore } = useAuthStore();

  const handleSignOut = async () => {
    await signOut();
    await signOutStore();
    navigate('/login', { replace: true });
  };

  const navigationItems = [
    { to: '/admin', label: 'Dashboard', end: true, visible: true },
    {
      to: '/admin/users',
      label: 'User Management',
      end: false,
      visible: accessLevel === 'SUPER_ADMIN',
    },
    { to: '/admin/settings', label: 'Settings', end: false, visible: true },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <DashboardHeader
        user={user}
        role={role}
        accessLevel={accessLevel}
        onSignOut={handleSignOut}
      />

      <div className="flex flex-1">
        <aside className="hidden w-64 shrink-0 border-r border-gray-200 bg-white lg:block">
          <nav className="sticky top-0 flex h-full flex-col p-4">
            <p className="mb-3 px-3 text-xs font-semibold uppercase tracking-wide text-gray-400">
              Navigation
            </p>
            <ul className="space-y-1">
              {navigationItems
                .filter((item) => item.visible)
                .map((item) => (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      end={item.end}
                      className={({ isActive }) =>
                        `${linkBaseClasses} ${
                          isActive
                            ? 'bg-primary-50 text-primary-700'
                            : 'text-gray-700 hover:bg-gray-50'
                        }`
                      }
                    >
                      {item.label}
                    </NavLink>
                  </li>
                ))}
            </ul>
          </nav>
        </aside>

        <main id="main-content" className="min-w-0 flex-1 px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
          <nav className="mb-6 flex gap-2 overflow-x-auto lg:hidden">
            {navigationItems
              .filter((item) => item.visible)
              .map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium ${
                      isActive
                        ? 'bg-primary-600 text-white'
                        : 'bg-white text-gray-700 ring-1 ring-gray-200'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
          </nav>

          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayoutPage;
